import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';

@Injectable()
export class UsuarioService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  obterUsuarioLogado(): Observable<any> {
    return this.http.get<any>(this.URL_API + `usuario/ObterUsuarioLogado/`);
  }

  alterarSenha(senhaAtual: string, novaSenha: string): Observable<any> {
    const data = {
      SenhaAtual: senhaAtual,
      NovaSenha: novaSenha,
    };
    return this.http.post<any>(this.URL_API + `usuario/alterarsenha/`, data).pipe(
      catchError((error: any) => observableThrowError(error)));
  }

}
